/**
 * License Release.
 *
 *
 * @beta
 */
export const LICENSE_RELEASE = 'license-release'
